import { iconSolidTriangle } from '@maxpreps/shared/ui/Icon/mp/SolidTriangle';
import React from 'react';
import styled from 'styled-components';
import useHasMounted from '../../hooks/useHasMounted';
import { IChildrenProps } from '../../models/utilTypes';
import THEME, { COLOR } from '../../styles/colors';
import Icon, { IconType } from '../../ui/Icon/Icon';

const StyledSportLinkDropdown = styled.div<{
  $direction?: 'left' | 'right';
  $isVisible?: boolean;
}>`
  cursor: initial;
  position: absolute;
  z-index: 100;
  top: 96%;
  ${({ $direction }) =>
    $direction === 'right' ? 'right: -10px;' : 'left: -20px;'}
  ${({ $isVisible }) => ($isVisible ? '' : 'display: none')};

  color: ${THEME.text.primary};
  background-color: ${THEME.surface.primary};

  border: ${props => props.theme.colors.school.primary};
  border-radius: 12px;
  box-shadow: 0 23px 73px -12px ${THEME.shadow.dark};

  padding: 8px 0;
`;

const StyledCaretContainer = styled.div<{ $direction: 'left' | 'right' }>`
  position: absolute;
  bottom: 100%;
  height: 16px;
  width: 100%;

  & > svg {
    position: absolute;
    top: 0;
    ${({ $direction }) =>
      $direction === 'right' ? 'right: 20px;' : 'left: 15px;'}
  }
`;

interface ISiteNavDropdownProps extends IChildrenProps {
  direction?: 'left' | 'right';
}

const SiteNavDropdown: React.FC<ISiteNavDropdownProps> = ({
  children,
  direction = 'left'
}) => {
  const hasMounted = useHasMounted();
  return (
    <StyledSportLinkDropdown $direction={direction} $isVisible={hasMounted}>
      <StyledCaretContainer $direction={direction}>
        <Icon
          iconType={IconType.MaxPreps}
          icon={iconSolidTriangle}
          color={COLOR.white}
          size={24}
        />
      </StyledCaretContainer>
      {children}
    </StyledSportLinkDropdown>
  );
};

export default SiteNavDropdown;
